export enum EventTaskStatus {
    New = 0,
    Active = 1,
    Closed = 2
}